import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function CardmsgC({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div className={`${css.cardmsgC} cardmsgC1 GtmModuleData-section`} data-section-id={css.cardmsgC} data-section-title={t('interior_design')}>
            <div className="card-msgs">
                <div className="card-title">{t('interior_design')} </div>
                <div className="card-desc">{t('interior_design_desc')} </div>
            </div>
            <div className="card-img">
                <EFVideo sources={['/video/deltapro/deltapro-design.webm', '/video/deltapro/deltapro-design.mp4']} />
            </div>
        </div>
    );
}
